import React, { useState, useEffect, useContext } from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import PanelCardWithHeading from "components/tickets/panelCardWithHeading";
import CreateComplainForm from "components/fileComplain/formSection/createComplainForm/createComplainForm";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import DivLayout from 'components/sales/divLayout/divLayout';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import moment from 'moment';
import Regex from 'services/utils/regex/Regex';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import { Button} from 'react-bootstrap';
import DocumentView from 'components/sales/downloadDocView/documentView';
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import { toast } from "react-toastify";

const EditComplain = ({
  match,
  history,
  documentUploadUrl,
  documentUrlData,
  raiseComplain,
  //getFormDropdowns,
  getComplains,
  // formDropdowns,
  viewDetails,
  viewComplainDetails,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [siteNo, setSiteNo] = useState();
  const [dropdownsData, setDropdownsData] = useState({});
  const [isModal, setIsModal] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [complainId, setComplainId] = useState("");
  const [showProjectListPopup, setShowProjectListPopup] = useState(false);
  const [complainList, setComplainList] = useState([]);
  const [complainDetails, setComplainDetails] = useState("");
  const [complainInfoData, setComplainInfoData] = useState('');
  const [className, setClassName] = useState('empty');

  // useEffect(() => {
  //   (async () => {
  //     setIsLoading(true);
  //     await getFormDropdowns(match.params.id);
  //     setIsLoading(false);
  //   })();
  // }, [getFormDropdowns]); 

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      setComplainId(match.params.id);
      const res = await viewDetails(match.params.id);
      setIsLoading(false);
    })();
  }, [viewDetails,match.params.id]);

  const onBlur = () => {
    if (complainInfoData.complain_description) setClassName('');
    else setClassName('empty');
  };

  // useEffect(() => {
  //   if (formDropdowns.complain_raised_by) {
  //     setDropdownsData(formDropdowns);
  //   }
  // }, [formDropdowns]);

  const addNewComplain = () => {
    setShowProjectListPopup(false);
  }
  const hideComplain = () => {
    setShowProjectListPopup(false);
  }

  useEffect(() => {
    if(viewComplainDetails !== null) {
        setIsLoading(true);
        setComplainDetails(viewComplainDetails);
        const complainInfoInputs = {
          ticket_id:match.params.id,
          complain_description: viewComplainDetails?.complain_description,
          document: '',
        };
        setComplainInfoData(complainInfoInputs);
        setIsLoading(false);
    }
  }, [viewComplainDetails]);

  const submit = async() => {
    setIsLoading(true);
    const url = `${Config.fileComplain.updateComplain}`;
    const { data } = await axios.post(url,complainInfoData);
    if(data && data?.response?.data === true) {
        setIsLoading(false);
        history.push(`${baseUrl}/complains-list`);
        toast.success('Complain updated sucessfully.');
    } else {
        setIsLoading(false);
        toast.error('Complain not updated, please try again.');
    }
    setIsLoading(false);
  }

  return (
    <Layout
      title={localization.editComplain}
      isLoading={isLoading}
      isGoback
      className={isFiled ? "requiredFileds" : ""}
    >
      <PanelCardWithHeading title={localization.detailComplain}>
        <div className="details-listing">
            <DivLayout heading={localization.complainId} data={complainDetails.id} />
            <DivLayout
              heading={localization.siteNumber}
              data={complainDetails.site_no}
            />
            <DivLayout
              heading={localization.siteName}
              data={complainDetails.site_name}
            />
            <DivLayout
              heading={localization.complainRaisedBy}
              data={complainDetails.complain_raised_by}
            />
            <DivLayout
              heading={localization.complainType}
              data={complainDetails.complain_type}
            />
            <DivLayout heading={localization.gate} data={complainDetails.gate} />
            <DivLayout heading={localization.amc} data={complainDetails?.amc} />
            <DivLayout
              heading={localization.product}
              data={complainDetails.product}
            />
            <DivLayout
              heading={localization.materialRequired}
              data={complainDetails.material_required}
            />
            <DivLayout
              heading={localization.insightsCategory}
              data={`${complainDetails.complain_faqs_question} [${complainDetails.complain_priority}]`}
            />
            <DivLayout
              heading="Is Internet present"
              data={complainDetails.is_internet}
            />
            <DivLayout
              heading="Call to client"
              data={complainDetails.call_client}
            />
            
            <DivLayout
              heading={localization.cDescription}
              data={complainDetails.complain_description}
            />
            <DivLayout
              heading={localization.createdOn}
              data={moment(complainDetails.created_at, 'DD-MM-YYYY HH:mm:ss').format(
                'DD-MM-YYYY HH:mma'
              )}
            />
            <DivLayout
              heading={localization.status}
              data={complainDetails.status}
              status
            />
            </div>
            {complainDetails.document && (complainDetails.document.map((document) => (
             <DocumentView attachment={document} />
            )))}
            <TextAreaInput
              type="text"
              rows={4}
              onBlur={onBlur}
              autoFocus={true}
              className={`${className} inline-css scrollbar-styling`}
              label={localization.addDescription}
              value={complainInfoData?.complain_description}
              inputValue={complainInfoData?.complain_description}
              regex={Regex.text.test(complainInfoData.complain_description)}
              required
              isStarRequired={true}
              errorMsg={localization.requiredDescription}
              handleChange={(e) => {
                setComplainInfoData({
                  ...complainInfoData,
                  complain_description: e.target.value,
                });
              }}
            />
            <div className="form-group form-btn">
              <FileUpload
                id="addAttachment"
                multiple="multiple"
                accept=".pdf,.png,.jpg,.jpeg,.doc"
                documentUploadUrl={documentUploadUrl}
                documentUrlData={documentUrlData}
                onChange={(val) =>
                  setComplainInfoData({
                    ...complainInfoData,
                    document: val,
                  })
                }
              >
              <span className="btn btn-transparent">
                {localization.uploadMultiAttachment}
              </span>
            </FileUpload>
            <div className='col-md-12 col-sm-12'>
            <div className={``}>
             <Button onClick={() => submit()}>{`Update Complain`}</Button>
             </div>
            </div>
            <br/>
            </div>
      </PanelCardWithHeading>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={() => setIsModal(false)}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.saveSuccessfully}</h5>
          <Link
            to={`${baseUrl}/view-complain/${complainId}`}
            className="btn btn-primary mb-4"
          >
            {localization.siteInformation}{" "}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
    </Layout>
  );
};

EditComplain.propTypes = {};

export default EditComplain;
